import React from "react";
import styled from "styled-components";

interface Props {
    label: string;
}

const LabelWrapper: React.FC<Props> = ({ label, children }) => {
    return (
        <Container>
            <Label>{label.toUpperCase()}</Label>
            <div>{children}</div>
        </Container>
    );
};

const Label = styled.div`
    font-size: 0.9rem;
    font-weight: ${(props) => props.theme.fontWeight.bold};

    color: #929cb9;

    margin-bottom: 0.25rem;
    user-select: none;
`;

const Container = styled.div`
    display: flex;
    flex-flow: column;
    margin-bottom: 2rem;

    & > *:last-child {
        display: flex;

        & > * {
            flex: 1;
        }
    }
`;

export default LabelWrapper;
